import React, { useState, useEffect } from "react";
import Swal from "sweetalert2";
import {
  AddBrandApi,
  AddBrandsToDefaultApi,
  AddCategoryToBrandApi,
  AddImeiDetailsApi,
  AddProductToCategoryApi,
  baseurl,
  GetImeiDetailsApi,
  getProfileApi,
  GetSubUserProfileApi,
  SetLimitCheckApi,
} from "../Utility/Api";
import DefaultServiceModel from "./DefaultServiceModel";
import LoadingBoxes from "./LoadingBoxes";

const ManageRepairDevices = (props) => {
  const [brands, setBrands] = useState([]);
  const [activeBrand, setActiveBrand] = useState(null);
  const [activeCategory, setActiveCategory] = useState(null);
  const [brandName, setBrandName] = useState("");
  const [seriesLine, setSeriesLine] = useState("");
  const [modelName, setModelName] = useState("");
  const [errors, setErrors] = useState({});
  const [seriesName, setSeriesName] = useState("");
  const [selectedBrandName, setSelectedBrandName] = useState(null);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [productName, setProductName] = useState("");
  const [showAddSeriesModal, setShowAddSeriesModal] = useState(false);
  const [showAddModelModal, setShowAddModelModal] = useState(false);
  const [showAddModelModal1, setShowAddModelModal1] = useState(false);
  const [showAddModelModal2, setShowAddModelModal2] = useState(false);
  const [defaultServices, setDefaultServices] = useState([]);
  const [selectedCategoryId, setSeelctedCategoryId] = useState();
  const [SelectedModelId, setSelectedModelId] = useState();
  const [step, setStep] = useState(1);
  const handleNext = () => {
    setStep(2); // Show SelectDeviceModal content
  };

  const handleBack = () => {
    setStep(1); // Go back to CreateTicket
  };

  const handleCloseAll = () => {
    // props?.onpress(); // Close parent modal
    setStep(1); // Reset step
  };

  const [loading, setLoading] = useState(false);
  const [expandedCategoryIndex, setExpandedCategoryIndex] = useState(0); // default first category open

  const handleCategoryClick = (index) => {
    setExpandedCategoryIndex((prevIndex) =>
      prevIndex === index ? null : index
    );
  };

  useEffect(() => {
    console.log("manageprops", props);
    GetAllBrandsCategoryandDevices();
    GetAllDefaultServices();
  }, []);

  const GetAllBrandsCategoryandDevices = () => {
    setLoading(true);
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    // fetch(`${baseurl}getAllBrandCategoriesAndSubproducts`, {
    fetch(`${baseurl}getDefaultBrands`, {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    })
      .then((response) => response.json())
      .then((result) => {
        setLoading(false);

        setBrands(result?.data || []);
      })
      .catch((error) => {
        setLoading(false);

        console.error("Error fetching categories:", error);
      });
  };
  const validateForm = () => {
    let newErrors = {};
    if (!brandName.trim()) newErrors.brandName = "Brand Name is required.";
    if (!seriesLine.trim())
      newErrors.seriesLine = "Product Series Line is required.";
    if (!modelName.trim()) newErrors.modelName = "Model Name is required.";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // If no errors, form is valid
  };

  const handleSubmit = () => {
    if (!validateForm()) return;
    setLoading(true);

    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      // name: brandName,
      // productCategoryId: "2",
      // description: "",
      // categories: [
      //   {
      //     categoryName: seriesLine,
      //     products: [{ name: modelName }],
      //   },
      // ],

      name: brandName,
      categoryName: seriesLine,
      deviceName: modelName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
   //  console.log("added brand raw", raw);
    fetch(`${baseurl}createOrUpdateDefaultBrands`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("add brands", result);
        if (result.status === true) {
          setLoading(false);

          GetAllBrandsCategoryandDevices();
          // Update brand list in the parent component
          setBrandName("");
          setSeriesLine("");
          setModelName("");
          setErrors({});
          setShowAddModelModal1(false);
        }
      })
      .catch((error) => {
        console.error(error);

        setLoading(false);
      });
  };

  const AddCategoryToBrand = () => {
    let local = localStorage.getItem("token");
    if ( !seriesName) {
      // Swal.fire("Please select a brand and enter a series name.");
      Swal.fire({
        title: "Please enter a series name.",

        customClass: {
          container: "custom-swal-container",

          confirmButton: "custom-swal-confirm-button",
        },
        confirmButtonColor: "#3085d6",
      });
      return;
    }
    setLoading(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      name: selectedBrandName,
      categoryName: seriesName,

      //  brandName: selectedBrandName,
      //  categoryName: seriesName,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    console.log("add category rawww", raw);
    fetch(AddBrandsToDefaultApi, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        //  console.log("category added response", result);
        if (result?.status === true) {
          setLoading(false);

          setSeriesName(""); // Clear input
          setShowAddSeriesModal(false);
          GetAllBrandsCategoryandDevices();
        }
      })
      .catch((error) => {
        setLoading(false);

        console.error(error);
      });
  };

  const AddProductToCategory = () => {
    let local = localStorage.getItem("token");
    if (!productName.trim()) {
      // alert("Please select brand, category and enter product name.");
      Swal.fire({
        title: "Please enter product name.",

        customClass: {
          container: "custom-swal-container",

          confirmButton: "custom-swal-confirm-button",
        },
        confirmButtonColor: "#3085d6",
      });
   
      return;
    }
    setLoading(true);

    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", `Bearer ${local}`);

    const raw = JSON.stringify({
      name: selectedBrandName,
      categoryName: selectedCategoryName,
      deviceName: productName.trim(),
      // brandName: selectedBrandName,
      // categoryName: selectedCategoryName,
      // productName: productName.trim(),
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    //  console.log("add product category rawww", raw);
    fetch(AddBrandsToDefaultApi, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log("result add product category", result);
        if (result?.status === true) {
          setLoading(false);

          GetAllBrandsCategoryandDevices();
          setProductName("");
          setShowAddModelModal(false);
        }
      })
      .catch((error) => {
        setLoading(false);

        console.error(error);
      });
  };
  const GetAllDefaultServices = () => {
    const userid = localStorage.getItem("userId");
    let local = localStorage.getItem("token");
    const myHeaders = new Headers();
    myHeaders.append("Authorization", `Bearer ${local}`);

    const requestOptions = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(`${baseurl}getDefaultServices`, requestOptions)
      .then((response) => response.json())
      .then((result) => {
        // console.log(result)
        if (result.status && result.data?.length > 0) {
          setDefaultServices(result.data[0].services);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };
  const OnPress = () => {
    setShowAddModelModal2(false);
  };

  return (
    <>
      {loading ? (
        <>
          <div className="loading-box">
            <LoadingBoxes />
          </div>
        </>
      ) : // <div className="landing_loader">
      //   <div className="innerloader">
      //     <img src="img/spin-1s-156px.gif" alt="" />
      //   </div>
      // </div>
      null}
      {step === 1 ? (
        <>
          <div
            className="modal-dialog modal-dialog-centered cusmodal_xl"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="menuitemsModalLabel">
                  Menu items
                </h5>
                <button
                  type="button"
                  className="close"
                  // data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    props?.props();
                    document
                      .querySelectorAll(".modal-backdrop")
                      .forEach((el) => el.classList.remove("modal-backdrop"));
                    props?.onClose1();
                  }}
                >
                  <span className="close_icon" />
                </button>
                <a
                  className="addbrand_btn"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault(); // prevent default navigation
                    setShowAddModelModal1(true);
                  }}
                >
                  <i className="fa fa-plus" /> Add Brand
                </a>
              </div>
              <div className="modal-body">
                <div className="custom_form menuitems_form">
                  <form
                    action=""
                    method=""
                    className="cus_form"
                    data-gtm-form-interact-id={0}
                  >
                    <div className="row">
                      <div className="col-md-12 ">
                        <div className="menuitem_list">
                          <ul>
                            {brands.map((brand) => (
                              <li
                                key={brand.id}
                                className={`mainitem ${
                                  activeBrand === brand.id ? "active" : ""
                                }`}
                                onClick={() => {
                                  setActiveBrand(
                                    activeBrand === brand.id ? null : brand.id
                                  );
                                  setSelectedBrandName(brand.name);
                                }}
                              >
                                <i className="fa fa-angle-right"></i>{" "}
                                {brand.name}
                                {activeBrand === brand.id && (
                                  <>
                                    <a
                                      className="menu_modal"
                                      href="#"
                                      // data-toggle="modal"
                                      // data-target="#addseriesModal"
                                      onClick={(e) => {
                                        e.preventDefault(); // prevent default navigation
                                        setShowAddSeriesModal(true);
                                      }}
                                    >
                                      <i className="fa fa-plus"></i> Add Series
                                    </a>
                                    <ul className="submenu">
                                      {brand.subproducts.map((category) => (
                                        <li
                                          key={category.categoryId}
                                          className={`subitem ${
                                            activeCategory ===
                                            category.categoryId
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={(e) => {
                                            e.stopPropagation(); // Prevents toggling brand when clicking category
                                            setActiveCategory(
                                              activeCategory ===
                                                category.categoryId
                                                ? null
                                                : category.categoryId
                                            );
                                            setSelectedCategoryName(
                                              category.categoryName
                                            );
                                          }}
                                        >
                                          <i className="fa fa-angle-right"></i>{" "}
                                          {category.categoryName}
                                          {activeCategory ===
                                            category.categoryId && (
                                            <>
                                              <a
                                                className="menu_modal"
                                                href="#"
                                                onClick={(e) => {
                                                  e.preventDefault(); // prevent default navigation
                                                  setShowAddModelModal(true);
                                                }}
                                              >
                                                <i className="fa fa-plus"></i>{" "}
                                                Add Model
                                              </a>
                                              <ul className="sub_submenu">
                                                {category.devices.map(
                                                  (product) => (
                                                    <li key={product.deviceId}>
                                                      <span>
                                                        {product.deviceName}
                                                      </span>
                                                      <a
                                                        href="#"
                                                        data-toggle="modal"
                                                        data-target="#editrepairproductModal"
                                                        onClick={(e) => {
                                                          handleNext();
                                                          e.preventDefault(); // prevent default navigation
                                                          setShowAddModelModal2(
                                                            true
                                                          );
                                                          setSelectedBrandName(
                                                            selectedBrandName
                                                          );
                                                          setSelectedCategoryName(
                                                            selectedCategoryName
                                                          );
                                                          setProductName(
                                                            product.deviceName
                                                          );
                                                          setSeelctedCategoryId(
                                                            category.categoryId
                                                          );

                                                          setSelectedModelId(
                                                            product.deviceId
                                                          );
                                                        }}
                                                      >
                                                        <img
                                                          src="assets/img/repair-edit-menuitem-icon.png"
                                                          alt="Edit"
                                                        />
                                                      </a>
                                                    </li>
                                                  )
                                                )}
                                              </ul>
                                            </>
                                          )}
                                        </li>
                                      ))}
                                    </ul>
                                  </>
                                )}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </>
      ) : (
        <>
          {showAddModelModal2 && (
            <div
              className="modal show d-block common_modal editrepairproduct_modal cus_repair_modal"
              id="editrepairproductModal"
              tabIndex={-1}
              role="dialog"
              aria-labelledby="editrepairproductModalLabel"
              aria-hidden="true"
            >
              <DefaultServiceModel
                product={productName}
                Brand={selectedBrandName}
                series={selectedCategoryName}
                onpress={OnPress}
                brandid={activeBrand}
                productid={SelectedModelId}
                seriesid={selectedCategoryId}
                prop={props?.prop}
                onBack1={handleBack}
                onClose1={handleCloseAll}
              />
            </div>
          )}
        </>
      )}
      {showAddModelModal1 && (
        <div
          className="modal show d-block common_modal addbrand_modal cus_repair_modal"
          id="addbrandModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="addbrandModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered cusmodal_sm"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addbrandModalLabel">
                  Add New Brand
                </h5>
                <button
                  type="button"
                  className="close"
                  aria-label="Close"
                  id="closeModalBtn"
                  onClick={() => {
                    setShowAddModelModal1(false);

                    setBrandName("");
                    setSeriesLine("");
                    setModelName("");
                    setSeriesName("");
                    setProductName("");
                  }}
                >
                  <span className="close_icon" />
                </button>
              </div>
              <div className="modal-body">
                <div className="custom_form addcustom_form">
                  <form className="cus_form">
                    <div className="row">
                      <div className="col-md-12">
                        {/* Brand Name Input */}
                        <div className="form_column col_full">
                          <div className="form-group">
                            <label className="cus_label">
                              Brand<span>*</span>
                            </label>
                            <div className="formfield selectcustomerboxcustmlist">
                              <input
                                type="text"
                                name="brand"
                                className="form-control"
                                placeholder="Brand Name"
                                value={brandName}
                                onChange={(e) => {
                                  setBrandName(e.target.value);

                                  if (errors.brandName) {
                                    setErrors({ ...errors, brandName: "" });
                                  }
                                }}
                              />
                              {errors.brandName && (
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "red",
                                  }}
                                >
                                  {errors.brandName}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Product Series Line Input */}
                        <div className="form_column col_full">
                          <div className="form-group">
                            <label className="cus_label">
                              Product Series Line<span>*</span>
                            </label>
                            <div className="formfield selectcustomerboxcustmlist">
                              <input
                                type="text"
                                name="seriesline"
                                className="form-control"
                                placeholder="Product Series Line Name"
                                value={seriesLine}
                                onChange={(e) => {
                                  setSeriesLine(e.target.value);
                                  if (errors.seriesLine) {
                                    setErrors({ ...errors, seriesLine: "" });
                                  }
                                }}
                              />
                              {errors.seriesLine && (
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "red",
                                  }}
                                >
                                  {errors.seriesLine}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>

                        {/* Model Name Input */}
                        <div className="form_column col_full">
                          <div className="form-group">
                            <label className="cus_label">
                              Model<span>*</span>
                            </label>
                            <div className="formfield selectcustomerboxcustmlist">
                              <input
                                type="text"
                                name="model"
                                className="form-control"
                                placeholder="Device Model Name"
                                value={modelName}
                                onChange={(e) => {
                                  setModelName(e.target.value);
                                  if (errors.modelName) {
                                    setErrors({ ...errors, modelName: "" });
                                  }
                                }}
                              />
                              {errors.modelName && (
                                <span
                                  style={{
                                    fontSize: "12px",
                                    color: "red",
                                  }}
                                >
                                  {errors.modelName}
                                </span>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Buttons */}
                    <div className="submit_modal_btn">
                      <button
                        type="button"
                        className="btn btn-default cancel_btn"
                        // data-dismiss="modal"
                        onClick={() => setShowAddModelModal1(false)}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary theme_btn"
                        onClick={handleSubmit}
                      >
                        Create
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}

      {showAddSeriesModal && (
        <div
          className="modal show d-block common_modal addseries_modal cus_repair_modal"
          id="addseriesModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="addseriesModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered cusmodal_sm"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addseriesModalLabel">
                  Add Series Line
                </h5>
                <button
                  type="button"
                  className="close"
                  // data-dismiss="modal"
                  aria-label="Close"
                  onClick={() => {
                    setShowAddSeriesModal(false);
                    setSeriesName("");
                  }}
                >
                  <span className="close_icon" />
                </button>
              </div>
              <div className="modal-body">
                <div className="custom_form addcustom_form">
                  <form
                    action=""
                    method=""
                    className="cus_form"
                    data-gtm-form-interact-id={0}
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form_column col_full">
                          <div className="form-group">
                            <label className="cus_label">
                              Series Name<span>*</span>
                            </label>
                            <div className="formfield selectcustomerboxcustmlist">
                              <input
                                type="text"
                                name="seriesname"
                                className="form-control"
                                placeholder="Enter Series Name"
                                value={seriesName}
                                onChange={(e) => setSeriesName(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="submit_modal_btn">
                      <button
                        type="button"
                        className="btn btn-default cancel_btn"
                        // data-dismiss="modal"
                        onClick={() => {
                          setShowAddSeriesModal(false);
                          setSeriesName("");
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary theme_btn"
                        onClick={AddCategoryToBrand}
                      >
                        Create
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showAddModelModal && (
        <div
          className="modal show d-block common_modal addmodel_modal cus_repair_modal"
          id="addmodelModal"
          tabIndex={-1}
          role="dialog"
          aria-labelledby="addmodelModalLabel"
          aria-hidden="true"
        >
          <div
            className="modal-dialog modal-dialog-centered cusmodal_sm"
            role="document"
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="addmodelModalLabel">
                  Add Model
                </h5>
                <button
                  type="button"
                  className="close"
                  onClick={() => {
                    setShowAddModelModal(false);
                    setProductName("");
                  }}
                  // data-dismiss="modal"
                  // aria-label="Close"
                >
                  <span className="close_icon" />
                </button>
              </div>
              <div className="modal-body">
                <div className="custom_form addcustom_form">
                  <form
                    action=""
                    method=""
                    className="cus_form"
                    data-gtm-form-interact-id={0}
                  >
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form_column col_full">
                          <div className="form-group">
                            <label className="cus_label">
                              Model Name<span>*</span>
                            </label>
                            <div className="formfield selectcustomerboxcustmlist">
                              <input
                                type="text"
                                name="modelname"
                                className="form-control"
                                placeholder="Model Name"
                                value={productName}
                                onChange={(e) => setProductName(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="submit_modal_btn">
                      <button
                        type="button"
                        className="btn btn-default cancel_btn"
                        // data-dismiss="modal"
                        onClick={() => {
                          setShowAddModelModal(false);
                          setProductName("");
                        }}
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        className="btn btn-primary theme_btn"
                        onClick={AddProductToCategory}
                      >
                        Create
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ManageRepairDevices;
